import React, {useMemo, useState} from 'react';
import ModalAttaches from "../../../../../components/modal/modal-attaches.jsx";
import InfoGrid from "../../../../../components/info-grid/info-grid.jsx";

const API_URL = import.meta.env.VITE_API_URL;
const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const imgExtensions = ["jpg", "jpeg", "png", "gif", "svg", "webp", "image/jpg", "image/jpeg", "image/png", "image/gif", "image/svg+xml",];

const limitFileName = (name, max = 18) => {
    if (!name) return "";
    return name.length > max ? `${name.slice(0, max)}...` : name;
};

export default function AttachmentContent({ attaches = [], printOptions }) {
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);

    const getFileExtension = (attach) => {
        return attach?.name?.split(".").pop()?.toLowerCase() ?? "";
    };

    const getExtension = (attach) => {
        return String(
            attach?.type ?? getFileExtension(attach)
        ).toLowerCase();
    };

    const isImageAttach = (attach) => {
        return imgExtensions.includes(getExtension(attach));
    };

    const getPreviewUrl = (attach) => {
        const extension = getFileExtension(attach);

        if (isImageAttach(attach)) return `${API_KEEPER}/ged/attach/${attach.attachId}`;
        return `${API_URL}/public/assets/img/file-types/${extension}.png`;
    };

    const openAttach = (attach) => {
        const extension = getExtension(attach);

        setSelectedFile({
            ...attach,
            attachId: attach.attachId,
            url: `${API_KEEPER}/ged/attach/${attach.attachId}`,
            extension,
            type: extension,
        });

        setModalOpen(true);
    };

    const showImages = printOptions?.showImages;

    return (
        <>
            <div className={`px-5 pt-5 mt-4 ${!showImages ? "print:hidden" : "print:block"}`}>
                <div className="relative h-full w-full p-3">
                    <div className={'absolute -top-3 -left-1 px-1 text-sm !text-[#52525C] !font-bold'}>Anexos:</div>

                    <section className="print:hidden grid grid-cols-4 gap-2 mt-3">
                        { attaches.map((attach, index) => {
                            const previewUrl = getPreviewUrl(attach);

                            return (
                                <div key={attach.id || index}>
                                    <div className="flex h-[184px] w-full items-center justify-center overflow-hidden">
                                        <img
                                            src={previewUrl}
                                            alt={attach.name}
                                            onClick={() => openAttach(attach)}
                                            className={`object-contain cursor-pointer max-h-[140px]`}
                                        />
                                    </div>

                                    <p className="info text-center text-[13px]" title={attach.name}>
                                        {limitFileName(attach.name)}
                                    </p>
                                </div>
                            );
                        })}
                    </section>

                    { showImages && (
                        <section className="hidden print:grid print:grid-cols-4 print:gap-2 print:mt-3">
                            { attaches.map((attach, index) => {
                                const previewUrl = getPreviewUrl(attach);

                                return (
                                    <div key={attach.id || index} className="print:break-inside-avoid">
                                        <div className="flex h-[184px] w-full items-center justify-center overflow-hidden">
                                            <img
                                                src={previewUrl}
                                                alt={attach.name}
                                                className={`object-contain max-h-[140px]`}
                                            />
                                        </div>

                                        <p className="info text-center text-[13px]" title={attach.name}>
                                            {limitFileName(attach.name)}
                                        </p>
                                    </div>
                                );
                            })}
                        </section>
                    )}
                </div>
            </div>

            <ModalAttaches
                open={modalOpen}
                setOpen={setModalOpen}
                file={selectedFile}
            />
        </>
    );
}